/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UtilizationAggregateResponse {
    getFixupPrototypeFunction() { return UtilizationAggregateResponse.fixupPrototype; }

    static newInstance(model: Partial<UtilizationAggregateResponse>): UtilizationAggregateResponse {
        let obj = Object.assign(new UtilizationAggregateResponse(), model);
        UtilizationAggregateResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UtilizationAggregateResponse>): UtilizationAggregateResponse {
        if (!model) return null;
        return UtilizationAggregateResponse.newInstance(<UtilizationAggregateResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UtilizationAggregateResponse) {
        if (!obj) return;

        models.UtilizationAggregateResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UtilizationAggregateResponse): boolean {
        Object.setPrototypeOf(obj, UtilizationAggregateResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let val of this.results) {
                models.ResourceLevelUtilizationAggregate.fixupPrototype(val);
            }
        }
    }

    /**
     * Resource Aggregate.
     */
    results: Array<models.ResourceLevelUtilizationAggregate>;

}
